<template>
    <div id="chooseSeatsComponent">
        <seat-map-indoor-individual
            v-if="seatGroups.length >= 118"
            :seats="seatGroups"
            :n-tickets="nTickets"
            :selections="chosenSeatGroups"
            @change="myChosenSeatGroups = $event"
            @valid="setSeatChoiceValid"
            @invalid="setSeatChoiceInvalid"
            ref="map"
        />

        <!--
        <seat-map-indoor-sections
            v-else-if="seatGroups.length > 0"
            :seat-groups="seatGroups"
            :n-tickets="nTickets"
            @change="updateSeatGroups"
            @valid="setSeatChoiceValid"
            @invalid="setSeatChoiceInvalid"
        />
        -->

        <div v-else class="loadingSeatMap">Loading seat map...</div>

        <div v-html="message || '&nbsp;'" class="feedback" />
        <!-- zzz allow relabeling -->
        <!-- zzz allow admin override ('save anyway') -->
        <!-- zzz optional reset button -->
        <div v-if="seatGroups.length && showButtons" class="actions">
            <button
                @click.prevent="doCancel"
                style="float: left;"
                v-text="'Cancel'"
                class="cancel"
            />
            <button
                :disabled="!mayContinue"
                @click.prevent="doContinue"
                v-text="'Continue'"
                class="continue"
            />
<!--
            <button
                @click.prevent="resetChosenSeatGroups"
                style="float: left;"
                v-text="'Clear'"
            />
-->
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import SeatMapIndoorIndividual from './SeatMapIndoorIndividual';
    // import SeatMapIndoorSections from './SeatMapIndoorSections';

    export default {
        components: {
            SeatMapIndoorIndividual,
            // SeatMapIndoorSections,
        },

        props: {
            showing: {
                type: Object,
                default: null,
            },
            showing_hashid: {
                type: String,
                default: null,
            },
            // seatsAvailable: {
            //     type: Number,
            //     default: null,
            // },
            nTickets: {
                type: [String, Number],
                default: 0,
            },
            chosenSeatGroups: {
                type: Array,
                default() { return [] },
            },
            showButtons: {
                type: Boolean,
                default: true,
            },
        },

        data() {
            return {
                // seatsAvailable: null,
                seatGroups: [],
                seatChoiceValid: false,
                message: '',
                myChosenSeatGroups: [],
            }
        },

        computed: {
            seatChoiceLabels() {
                return this.seatGroups
                    .filter(sg => this.myChosenSeatGroups.includes(sg.hashid))
                    .map(sg => sg.label)
                ;
            },
            mayContinue() {
                return this.nTickets > 0 && this.seatChoiceValid;
            },
        },

        watch: {
            showing_hashid: {
                immediate: true,
                handler() {
                    return this.loadShowing();
                },
            },
            showing: {
                immediate: true,
                handler() {
                    if (!this.showing) {
                        this.seatGroups.splice(0, this.seatGroups.length);
                        return;
                    }
                    this.seatGroups.splice(0, this.seatGroups.length, ...this.showing.seatGroups.reverse());
                    // this.myChosenSeatGroups.splice(0, this.myChosenSeatGroups.length);
                    this.myChosenSeatGroups = JSON.parse(JSON.stringify(this.chosenSeatGroups));
                },
            },
            mayContinue(cur) {
                this.$emit('change', cur, this.myChosenSeatGroups, this.seatChoiceLabels);
            },
        },

        methods: {
            reset() {
                if (this.$refs.map) {
                    this.$refs.map.reset();
                }
            },

            loadShowing() {
                if (!this.showing_hashid) {
                    return;
                }



                let vue = this;
                // axios.get('/api/showings/' + this.showing.hashid + '/seats-available')
                //     .then(response => {
                //         console.debug(response.data);
                //         vue.seatsAvailable = response.data;
                //     })
                // ;
                return axios.get('/api/showings/' + this.showing_hashid + '/seat-groups')
                    .then(function(response) {
                        vue.seatGroups.splice(0, vue.seatGroups.length, ...response.data);
                    })
                    .catch(function(error) {
                        console.error(error);
                    })
                ;
            },

            clearChosenSeatGroups() {
                this.seatGroups.splice(0, this.seatGroups.length);
            },

            setSeatChoiceValid() {
                this.seatChoiceValid = true;
                this.message = '';
            },

            setSeatChoiceInvalid(message) {
                this.seatChoiceValid = false;
                this.message = this.nTickets > 0
                    ? message
                    : 'Set the number of tickets to buy.'
                ;
            },

            resetChosenSeatGroups() {
                this.myChosenSeatGroups.splice(0, this.myChosenSeatGroups.length, ...this.chosenSeatGroups);
            },

            doContinue() {
                this.$emit('chosen', this.myChosenSeatGroups, this.seatChoiceLabels);
            },

            doCancel() {
                this.$emit('cancel');
            },
        },
    }
</script>

<style lang="scss">

.loadingSeatMap {
    margin: 20px auto;
    text-align: center;
    font-size: clamp(12pt, 2vw, 20pt);
    color: #d88d34;
}
#chooseSeatsComponent {
    position: relative;

    button {
        float: right;
    }

    .feedback {
        margin: 5px 0;
        font-size: 90%;
        font-weight: bold;
        text-align: center;
        color: #b21d28;
    }

    .actions {
        button {
            display: inline-block;
            padding: 5px;
            width: 7.5em;
            background-color: #e0a55f;
            color: #052036;

            &[disabled] {
                background-color: #ccc;
                color: #444;
            }

            &.cancel {
                font-size: 75%;
                background-color: #ebdaad;
            }
        }
    }
}
</style>
